import React from 'react';
import { Layout } from 'antd';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from './styles.module.scss';
import './styles.scss';
const { Header, Content } = Layout;

const DashboardLayout = (props) => {
    return (
        <Layout className="layout">
            <Header>
                <div className={styles.headerWrap}>Example Demo</div>
            </Header>
            <Content style={{ padding: '0 50px' }}>
                <div className="site-layout-content">
                    {props.children}
                </div>
                <ToastContainer />
            </Content>
        </Layout>

    );
};
export default DashboardLayout;
